import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = [ "thumbnail", "item" ]

  toggle(e) {
    e.preventDefault()
    e.stopPropagation()
    const activeThumbnail = document.getElementById(`${e.currentTarget.getAttribute("aria-controls")}-thumbnail`)

    // Switch the active tab
    this.itemTargets.forEach(element => {
      element.parentNode.removeAttribute("aria-expanded")
    })

    e.currentTarget.parentNode.setAttribute("aria-expanded", true)

    // Switch the visible thumbnail
    this.thumbnailTargets.forEach(element => {
      element.classList.remove("active")
    })

    setTimeout(() => {
      activeThumbnail.classList.add("active")
    }, 250)
  }
}
